<script>
//import Multiselect from "vue-multiselect";
import {required, email} from "vuelidate/lib/validators";

import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import "vue-multiselect/dist/vue-multiselect.min.css";
import UsuarioService from "@/services/UsuarioService";
const itemService = new UsuarioService();


import InfoModel from "@/classes/usuario";
const infoModel = new InfoModel();

import HelperJS from "@/functions/general";
const helper = new HelperJS();

/**
 * Add-product component
 */
const nameSeccion = 'Usuario';
//const namePlural = nameSeccion+'s';
const routeParentName = 'usuarios';

export default {
  page: {
    title: nameSeccion,
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: nameSeccion,
      actionCreate: true,
      info_page:{
        roles:[{id:1, text:'Administrador'}, {id:2, text:'Recepción'}, {id:3, text:'Repartidor'}],       
        routeParentName: null,
        routeBack: null,
        nameSeccion: null,
      },
      objectData:{},
      items: [
        {
          text: null,
        },
        {
          text: null,
          active: true,
        },
      ],
      submitted: false,

      
    };
  },
  validations: {
      objectData: {
        name: {
          required,
        },
        role: {
          required,
        },
        email:{
          required,
          email
        }
      },
    },
  middleware: "authentication",
  
  created(){

    this.initPage();
  },
  
  methods: {
    async initPage(){
        
        this.info_page.routeParentName = routeParentName;
        this.info_page.nameSeccion = nameSeccion;
        this.info_page.routeBack = '/'+routeParentName;
        let text_page = 'Agregar '
        
        this.objectData = JSON.parse(JSON.stringify(infoModel.fillable));
        if(this.$route.name===nameSeccion+'Edit'){          
          this.actionCreate = false;
          text_page = 'Editar';

          itemService.getById(this.$route.params.id).then(async response=>{  
            let data = response.data.object_data;
            this.objectData =   JSON.parse(JSON.stringify(new InfoModel(data)));
          })
        }
        this.items[0].text= nameSeccion
        this.items[1].text= text_page+' '+nameSeccion;
      },
      async updateForm(){
      
          let formData = JSON.parse(JSON.stringify(this.objectData));
          if(this.actionCreate){
            delete formData.id;
            await itemService.create(formData)
          }else{
            await itemService.update(formData)
          }
          this.successForm(this.info_page.routeBack);
      
      },

      successForm(route){
        Swal.fire("¡Operación exitosa!", "Información guardada con éxito", "success").then(() => {
        this.$router.push({
              path: route,
            });
        });
    },
    cancelForm(){
      this.$router.push({
        path:'/'+routeParentName,
      });
    },
      
      validateForm(){

        this.submitted = true;
        if(this.$v.$error===false &&  this.$v.$invalid===false){
          this.updateForm();
        }
        
      this.$v.$touch();
      },
      slugify(stringValue){

        return helper.convertToSlug(stringValue);
      },
     routeGo(textRoute){
      this.$router.push({
        path: textRoute,
      });
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div id="addproduct-accordion" class="custom-accordion">
          <div class="card">
          
              <div class="p-4">
                <div class="media align-items-center">
                  <div class="me-3">
                    <div class="avatar-xs">
                      <div
                        class="avatar-title rounded-circle bg-soft-primary text-primary"
                      >
                        01
                      </div>
                    </div>
                  </div>
                  <div class="media-body overflow-hidden">
                    <h5 class="font-size-16 mb-1">Información general</h5>
                    <p class="text-muted text-truncate mb-0">
                      Completa todos los datos
                    </p>
                  </div>
                  <i
                    class="mdi mdi-chevron-up accor-down-icon font-size-24"
                  ></i>
                </div>
              </div>
            

            <b-collapse
              data-parent="#addproduct-accordion"
              id="accordion-1"
              visible
              accordion="my-accordion"
            >
              <div class="p-4 border-top">
                <form>
                 
                  <div class="row">
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label for="name">Nombre</label>
                        <input
                          id="name"
                          name="name"
                          v-model="objectData.name"
                          type="text"
                          class="form-control"
                          :class="{
                            'is-invalid': submitted && $v.objectData.name.$error,
                          }"
                        />
                        <div
                          v-if="submitted && $v.objectData.name.$error"
                          class="invalid-feedback">
                          <span v-if="!$v.objectData.name.required"
                            >Campo requerido</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                       <div class="mb-3">
                        <label for="name">Rol</label>
                        <select class="form-control select2" v-model="objectData.role"  :class="{
                            'is-invalid': submitted && $v.objectData.role.$error,
                          }">
                        <option :value="role.id" v-for="role in info_page.roles" :key="role.id" v-text="role.text"></option>
                        </select>
                        <div
                          v-if="submitted && $v.objectData.role.$error"
                          class="invalid-feedback">
                          <span v-if="!$v.objectData.role.required"
                            >Campo requerido</span
                          >
                        </div>
                      </div>
                    </div>
                
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                  
                  
                      <div class="mb-3">
                        <label>Correo electrónico</label>
                          <input
                            v-model="objectData.email"
                            type="email"
                            name="email"
                            class="form-control"
                            :class="{
                              'is-invalid': submitted && $v.objectData.email.$error,
                            }"
                            placeholder="Ingresar Email"
                          />
                          <div v-if="submitted && $v.objectData.email.$error" class="invalid-feedback">
                            <span v-if="!$v.objectData.email.required"
                              >Campo requerido.</span>
                            <span v-if="!$v.objectData.email.email"
                              >Añadir un correo eléctronico válido.</span>
                          </div>
                      </div>
                    </div>
                    
                    <div class="col-md-6">
                      <div class="form-group mb-3">
                          <label>Contraseña</label>
                          <input
                            v-model="objectData.password"
                           
                            type="password"
                            class="form-control"
                          :class="{
                            'is-invalid': submitted && $v.objectData.password.$error,
                          }"
                          />
                        
                           <div
                          v-if="submitted && $v.objectData.password.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.objectData.password.required"
                            >Campo requerido.</span
                          >
                        </div>
                      </div>
                       
                    </div>
                  </div>
                
                </form>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col text-end ms-1">
        <a  class="btn btn-danger"  @click.prevent="cancelForm()">
          <i class="uil uil-times me-1"></i> Cancelar
        </a>
        <a  class="btn btn-success ms-1"  @click.prevent="validateForm()">
          <i class="uil uil-file-alt me-1" ></i> Guardar cambios
        </a>
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>
